var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    viewBox: "0 0 55 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9583 48.125V43.5417C38.9583 41.1105 37.9926 38.7789 36.2735 37.0599C34.5544 35.3408 32.2228 34.375 29.7917 34.375H11.4583C9.02717 34.375 6.69559 35.3408 4.97651 37.0599C3.25743 38.7789 2.29166 41.1105 2.29166 43.5417V48.125",
    stroke: "#62B0DA",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 25.2083C25.6876 25.2083 29.7917 21.1043 29.7917 16.0417C29.7917 10.9791 25.6876 6.875 20.625 6.875C15.5624 6.875 11.4583 10.9791 11.4583 16.0417C11.4583 21.1043 15.5624 25.2083 20.625 25.2083Z",
    stroke: "#62B0DA",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7083 48.125V43.5417C52.7068 41.5106 52.0308 39.5376 50.7865 37.9324C49.5421 36.3272 47.7999 35.1807 45.8333 34.6729",
    stroke: "#62B0DA",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 7.17292C38.6384 7.67778 40.3861 8.82453 41.6342 10.4324C42.8822 12.0402 43.5596 14.0177 43.5596 16.0531C43.5596 18.0885 42.8822 20.066 41.6342 21.6739C40.3861 23.2817 38.6384 24.4285 36.6667 24.9333",
    stroke: "#62B0DA",
    strokeWidth: 4.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2d1770b3655f1512f081bd0f4d6c8c3f.svg";
export { ForwardRef as ReactComponent };